module.exports = __webpack_public_path__ + "media/images/invite-preview-0973530d440ff23bb94b726f3eafbf43.png";